import { render } from "./TheProfile.vue?vue&type=template&id=4d1f55b4&scoped=true"
import script from "./TheProfile.vue?vue&type=script&lang=js"
export * from "./TheProfile.vue?vue&type=script&lang=js"

import "./TheProfile.vue?vue&type=style&index=0&id=4d1f55b4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-4d1f55b4"

export default script